import { apiClient } from '../lib/api';

export interface Device {
  id: string;
  deviceUid: string;
  nickname: string | null;
  displayName: string;
  firmwareVersion: string | null;
  hardwareVersion: string | null;
  status: string;
  lastSeenAt: string | null;
  registeredAt: string;
  labId: string;
  labName: string;
  testCount: number;
}

export const devicesApiService = {
  async getDevices(labId?: string): Promise<Device[]> {
    const params = labId ? { labId } : {};
    const response = await apiClient.get<{ items: Device[] }>('/api/v1/devices', { params });
    return response.data.items;
  },

  async updateNickname(id: string, nickname: string | null): Promise<Device> {
    const response = await apiClient.patch<Device>(`/api/v1/devices/${id}`, { nickname });
    return response.data;
  },
};
